import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// --- Error Handling ---
import { NotFoundComponent } from './components/error-handling/not-found/not-found.component';
import { ServerErrorComponent } from './components/error-handling/server-error/server-error.component';
import { AccessDeniedComponent } from './components/error-handling/access-denied/access-denied.component';

// --- Admin Components ---
import { AdminPanelComponent } from './components/admin/admin-panel/admin-panel.component';
import { UserManagementComponent } from './components/admin/user-management/user-management.component';
import { AuditsComponent } from './components/admin/audits/audits.component';
import { PermissionGroupsComponent } from './components/admin/permission-groups/permission-groups.component';
import { PermissionGroupEditModalComponent } from './components/admin/permission-group-edit-modal/permission-group-edit-modal.component';
import { EndpointPermissionsComponent } from './components/admin/endpoint-permissions/endpoint-permissions.component';
import { EndpointPermissionEditModalComponent } from './components/admin/endpoint-permission-edit-modal/endpoint-permission-edit-modal.component';
import { RemovedEndpointsComponent } from './components/admin/removed-endpoints/removed-endpoints.component';

// --- Tenant Components (Agora parte do Admin) ---
import { TenantComponent } from './components/admin/tenant/tenant.component';
import { TenantModalComponent } from './components/admin/tenant/tenant-modal/tenant-modal.component';
import { TenantPreviewModalComponent } from './components/admin/tenant/tenant-preview-modal/tenant-preview-modal.component';

// --- Currency Management ---
import { CurrencyManagementComponent } from './components/admin/currency-management/currency-management.component';
import { CurrencyAdminModalComponent } from './components/admin/currency-management/currency-admin-modal/currency-admin-modal.component';
import { IntegrationsComponent } from './components/admin/integrations/integrations.component';
import { IntegrationSystemModalComponent } from './components/admin/integrations/integration-system-modal/integration-system-modal.component';
import { IntegrationFieldModalComponent } from './components/admin/integrations/integration-field-modal/integration-field-modal.component';
import { ApiClientModalComponent } from './components/admin/integrations/api-client-modal/api-client-modal.component';


// --- Auth Related ---
import { ConfirmemailComponent } from './components/confirmemail/confirmemail.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { UserEditModalComponent } from './components/auth/user-edit-modal/user-edit-modal.component';
import { AuthLayoutComponent } from './components/auth/auth-layout/auth-layout.component';
// --- Shared & PrimeNG ---
import { SharedModule } from '../shared/shared.module';
import { TabsModule } from 'primeng/tabs';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PickListModule } from 'primeng/picklist';
import { UiSwitchModule } from 'ngx-ui-switch'; // Adicionado pq o tenant modal usa
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { TextareaModule } from 'primeng/textarea';
import { getStoredToken } from './utils/auth-storage';

export function tokenGetter() {
  return getStoredToken();
}

@NgModule({
  declarations: [
    NotFoundComponent,
    ServerErrorComponent,
    AccessDeniedComponent,
    AdminPanelComponent,
    AuditsComponent,
    PermissionGroupsComponent,
    PermissionGroupEditModalComponent,
    EndpointPermissionsComponent,
    EndpointPermissionEditModalComponent,
    RemovedEndpointsComponent,
    UserManagementComponent,
    ConfirmemailComponent,
    ChangepasswordComponent,
    // Tenant
    TenantComponent,
    TenantModalComponent,
    TenantPreviewModalComponent,
    UserEditModalComponent,
    // Currency Management
    CurrencyManagementComponent,
    CurrencyAdminModalComponent,
    IntegrationsComponent,
    IntegrationSystemModalComponent,
    IntegrationFieldModalComponent,
    ApiClientModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    // TenantModule, <--- REMOVIDO
    TabsModule,
    TableModule,
    SelectModule,
    InputNumberModule,
    MultiSelectModule,
    CheckboxModule,
    ButtonModule,
    InputTextModule,
    PickListModule,
    DialogModule,
    TooltipModule,
    TextareaModule,
    UiSwitchModule,
    AuthLayoutComponent,
  ],
  providers: [],
})
export class CoreModule {}
